import createPersistedState from 'vuex-persistedstate'
import apiUrl from '../helpers/apiUrl'
import axios from 'axios'
import Vuex from 'vuex'

import mockResponsiveFunctions from '../mock/mock-response-functions'
import mockdb from '../mock/mock-db'
import { mockdbchart, generatedObj } from '../mock/mock-db-chart'

import { commonStore } from './modules/common.js'
import { corporateStore } from './modules/corporate.js'
import { myPagesStore } from './modules/myPages.js'
import { GROUP_FILTER as gf } from '../helpers/constants'

const myPagesWrapper = document.querySelector('div.vue-my-pages')

let isCorporate = myPagesWrapper ? (document.querySelector('meta[name="corporate"]')?.content ?? '') === 'true' : window.location.href.includes('--energikonto')
let currentBuildVersion = myPagesWrapper ? document.querySelector('meta[name="version"]')?.content ?? '' : '1.0.0.0'
let currentIsCorporateState = JSON.parse(sessionStorage.getItem('vuex') ?? '{}')?.myPagesCorporate

if (isCorporate !== currentIsCorporateState) {
  console.log('[VUEX]', 'Corporate state changed: index')
  sessionStorage.removeItem('vuex')
}

let persistedStateParams = isCorporate
  ? [
      'activeCustomer',
      'activeCustomerId',
      'activeDeliverySite',
      'consumptionChartData',
      'consumptionDataReady',
      'deliverySiteInformation',
      'deliverySites',
      'invoiceData',
      'numberOfDeliverySites',
      'invoiceSettingsData',
      'invoiceSendMethodData',
      'meterReadingsData',
      'powerOutageNotifications',
      'customers',
      'myPagesCorporate',
      'userName',
      'pendingRealTimeMeasurementData',
      'currentSession',
      'groups'
    ]
  : [
      'activeCustomer',
      'activeCustomerId',
      'activeDeliverySite',
      'activeDeliverySiteId',
      'numberOfDeliverySites',
      'consumptionChartData',
      'consumptionDataReady',
      'deliverySiteInformation',
      'deliverySites',
      'invoiceData',
      'invoiceSettingsData',
      'invoiceSendMethodData',
      'meterReadingsData',
      'powerOutageNotifications',
      'customers',
      'myPagesCorporate',
      'userName',
      'pendingRealTimeMeasurementData',
      'currentSession'
    ]

//https://github.com/robinvdvleuten/vuex-persistedstate
const dataState = createPersistedState({
  storage: window.sessionStorage,
  paths: persistedStateParams
})

const axiosMyPagesInstance = axios.create()
axiosMyPagesInstance.defaults.headers.common['Accept-Language'] = document?.documentElement.lang ?? 'se'

const mocks = mockResponsiveFunctions(axiosMyPagesInstance, mockdb, mockdbchart, generatedObj)
const addNotification = (context, response) => {
  context.commit('pushNotification', {
    type: [200, 204].includes(response.status) ? 'success' : 'error',
    message: response.data.messages?.join(' ') ?? ''
  })
}

export const formatErrorEmptyResponse = (statusCode, errorMessages) => {
  if (statusCode === 200) return null
  if (!errorMessages || (!errorMessages.heading && !errorMessages[statusCode]))
    return {
      status: statusCode,
      heading: `${statusCode}`,
      message: 'Translation missing'
    }

  if (errorMessages.heading) {
    return {
      status: statusCode,
      heading: errorMessages.heading,
      message: errorMessages.text
    }
  }

  return {
    status: statusCode,
    heading: errorMessages[statusCode].heading,
    message: errorMessages[statusCode].message
  }
}

const state = () => ({
  //MY PAGES
  optInOutInformation: [],
  deliverySiteInformation: {},
  consumptionChartData: {},
  deliverySiteSelectorDesktopOpen: false,
  deliverySiteSelectorMobileOpen: false,
  meterReadingsData: {
    totalItemsCount: 5,
    items: [],
    reset: false
  },
  notifications: [],

  overviewPowerOutageData: {
    items: []
  },
  overviewInvoiceData: {
    items: []
  },
  invoiceData: {
    totalItemsCount: 5,
    items: [],
    reset: false
  },
  invoiceSettingsData: null,
  invoiceSendMethodData: null,
  accountSettingsEmailData: {},
  accountSettingsPasswordData: {},
  powerOutageNotifications: {},
  realTimeMeasurementData: {},
  customerDetails: null,
  contactDetails: null,
  chartDirection: 'Consumption',

  //COMMON
  numberOfDeliverySites: 0,
  myPagesCorporate: isCorporate,
  customerServiceAdminImpersonate: {},
  globalServerError: null,
  modal: null,
  deliverySites: [],
  activeDeliverySiteId: null,
  activeDeliverySite: null,
  consumptionDataReady: false,
  deliverySitesLoading: false,
  pendingRealTimeMeasurementData: [],
  currentSession: null,

  //CORPORATE
  initiallyChosenDeliverySiteId: null,
  customers: [],
  activeCustomer: null,
  activeCustomerId: null,
  deliverySitesData: {
    totalItemsCount: 5,
    items: [],
    reset: false
  },
  deliverySitesGroupsData: {
    totalItemsCount: 5,
    items: [],
    reset: false
  },
  deliverySitesSearchData: {
    totalItemsCount: 5,
    items: [],
    reset: false
  },
  powerOutageNotificationTableData: {
    totalItemsCount: 5,
    items: [],
    reset: false
  },
  creditPaymentsTableData: {
    totalItemsCount: 5,
    items: [],
    reset: false
  },
  possiblePayouts: [],
  bankAccountDetails: null,
  deliverySiteSelectorOnPage: false,
  activeSubscriptions: {},
  groups: [],
  groupData: {},
  deliverySite_GroupFilter: gf.DELIVERY_SITES,
  deliverySite_EditModeActive: false,
  tabValue: null
})

const common = commonStore(axiosMyPagesInstance, mocks, mockdb, apiUrl, addNotification)
const corporate = corporateStore(axiosMyPagesInstance, mocks, mockdb, apiUrl, addNotification)
const myPages = myPagesStore(axiosMyPagesInstance, mocks, mockdb, apiUrl, addNotification)
const EllevioStore = new Vuex.Store({
  state,
  getters: {
    ...common.getters,
    ...corporate.getters,
    ...myPages.getters
  },
  actions: {
    ...common.actions,
    ...corporate.actions,
    ...myPages.actions
  },
  mutations: {
    ...common.mutations,
    ...corporate.mutations,
    ...myPages.mutations
  },
  plugins: [dataState]
})

axiosMyPagesInstance.interceptors.response.use(
  (response) => {
    const newBuildVersion = response.data?.meta?.version

    if (response.status === 200 && newBuildVersion && newBuildVersion !== currentBuildVersion) {
      console.log('[VUEX]', 'Versions differ - clear session state')
      sessionStorage.removeItem('vuex')
      window.location.reload()
      return {}
    }

    return response
  },
  (error) => {
    let env = {}
    try {
      env = import.meta.env
      if (typeof env !== 'object') env = {}
    } catch (_) {
      env = {}
    }

    const development = env.STORYBOOK === 'true'
    if (!development && error.response.status === 403) {
      sessionStorage.removeItem('vuex')
      window.location.reload()
      return
    }

    return {
      status: error?.response?.status ?? 204,
      data: {
        data: error?.response?.data?.data ?? {},
        meta: error?.response?.data?.meta ?? {},
        messages: error?.response?.data?.messages ?? [],
        errors: error?.response?.data?.errors ?? []
      }
    }
  }
)

export default EllevioStore
